import { createContext, useContext, useMemo } from "react";
import createScorecardService from "../home.service";
import { useImpersonation } from "../../../contexts/ImpersonationContext";

const ScorecardServiceContext = createContext();

export function ScorecardServiceProvider({ children }) {
  const { impersonatedUser } = useImpersonation();
  const impersonatedEmail = impersonatedUser?.email ?? null;

  const scorecardService = useMemo(
    () => createScorecardService({
      employeeEmailOverride: impersonatedEmail,
      managerEmailOverride: impersonatedEmail,
    }),
    [impersonatedEmail]
  );

  return (
    <ScorecardServiceContext.Provider value={scorecardService}>
      {children}
    </ScorecardServiceContext.Provider>
  );
}

export function useScorecardService() {
  const context = useContext(ScorecardServiceContext);
  if (context === undefined) {
    throw new Error("useScorecardService must be used within a ScorecardServiceProvider");
  }
  return context;
}

export default ScorecardServiceContext;
